import axios from 'axios'
import { getAPIBaseURL } from './helpers'

const base = () => `${getAPIBaseURL()}/v1`

const getAuthHeaders = () => {
  const token = localStorage.getItem('token')
  return token ? { 'token': token } : {}
}

export const uploadEventImage = async (file) => {
  try {
    const url = `${base()}/events/upload-image`
    const headers = {
      ...getAuthHeaders()
      // Don't set Content-Type, let browser set it with boundary for multipart/form-data
    }
    
    const formData = new FormData()
    formData.append('image', file)
    
    const res = await axios.post(url, formData, {
      headers,
      withCredentials: true
    })
    
    if (res.status === 200) {
      return { status: res.status, data: res.data.data }
    }
    return { status: res.status || 500, error: res.data?.data || res.data?.message || 'Failed to upload image' }
  } catch (error) {
    return { 
      status: error.response?.status || 500, 
      error: error.response?.data?.data || error.response?.data?.message || 'Failed to upload image' 
    }
  }
}

export const uploadOfferImage = async (file) => {
  try {
    const url = `${base()}/offers/upload-image`
    const headers = {
      ...getAuthHeaders()
      // Don't set Content-Type, let browser set it with boundary for multipart/form-data
    }
    
    const formData = new FormData()
    formData.append('image', file)
    
    const res = await axios.post(url, formData, {
      headers,
      withCredentials: true
    })
    
    if (res.status === 200) {
      return { status: res.status, data: res.data.data }
    }
    return { status: res.status || 500, error: res.data?.data || res.data?.message || 'Failed to upload image' }
  } catch (error) {
    return { 
      status: error.response?.status || 500, 
      error: error.response?.data?.data || error.response?.data?.message || 'Failed to upload image' 
    }
  }
}

export const uploadOfferVideo = async (file) => {
  try {
    const url = `${base()}/offers/upload-video`
    const headers = {
      ...getAuthHeaders()
      // Don't set Content-Type, let browser set it with boundary for multipart/form-data
    }
    
    const formData = new FormData()
    formData.append('video', file)
    
    const res = await axios.post(url, formData, {
      headers,
      withCredentials: true
    })
    
    if (res.status === 200) {
      return { status: res.status, data: res.data.data }
    }
    return { status: res.status || 500, error: res.data?.data || res.data?.message || 'Failed to upload video' }
  } catch (error) {
    return { 
      status: error.response?.status || 500, 
      error: error.response?.data?.data || error.response?.data?.message || 'Failed to upload video' 
    }
  }
}

